import React, { Component } from 'react'
import styled from 'styled-components'
import Logo from '../Logo'
import { Link } from 'react-router-dom'
import { device, menuItems } from '../../../utils/helpers'
import IconNav from './IconNav'

const Wrapper = styled.footer`
  display: flex;
  flex-direction: column;
  text-align: center;
  background: ${props => props.theme.color.bgMedium};
  align-items: center;
  padding: 1.5rem;

  @media ${device.tablet} {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-template-rows: 150px 50px 0px;
    grid-template-areas:
      '. logo . contact . service service .'
      '. noleggia noleggia noleggia noleggia noleggia noleggia .'
      '. strutture strutture strutture strutture strutture social .'
      'footer footer footer footer footer footer footer footer';
    text-align: left;
    padding: 0;
    padding-top: 20px;
  }

  @media ${device.laptopM} {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-template-rows: 100px 100px;
    grid-template-areas:
      '. logo . . contact . service service'
      '. noleggia noleggia noleggia strutture strutture strutture social'
      'footer footer footer footer footer footer footer footer';
    text-align: left;
    padding: 0;
    padding-top: 20px;
  }

  @media ${device.laptopL} {
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: 100px 100px;
    grid-template-areas:
      '. logo . contact service .'
      '. noleggia noleggia strutture strutture social'
      'footer footer footer footer footer footer';
  }
`

const Title = styled.h4`
  font-size: 22px;
  font-family: 'BarlowExtraBold';
  color: #4d4d4d;
  text-transform: uppercase;

  @media ${device.tablet} {
    font-size: 18px;
    padding-bottom: 0.8rem;
  }
`

const Section = styled.div`
  padding: 1.5rem;

  &:first-child {
    padding: 0;
  }

  @media ${device.tablet} {
    padding: 0;
  }
`

const HR = styled.hr`
  width: 100%;
  color: #fff;

  @media ${device.tablet} {
    display: none;
  }
`

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #fff;

  &:hover {
    color: ${props => props.theme.color.hoverPrimary};
  }
`

const StyledLinkNormal = styled.a`
  text-decoration: none;
  color: #fff;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.color.hoverPrimary};
  }
`

const FooterLink = styled(Link)`
  text-decoration: none;
  color: #4d4d4d;

  &:hover {
    color: ${props => props.theme.color.hoverPrimary};
  }
`

const FooterLinkA = styled.a`
  text-decoration: none;
  color: #4d4d4d;

  &:hover {
    color: ${props => props.theme.color.hoverPrimary};
  }
`

const List = styled.ul`
  padding-top: 20px;
  list-style: none;

  @media ${device.tablet} {
    padding-top: 0;
  }
`

const MenuList = styled.ul`
  padding-top: 20px;

  @media ${device.tablet} {
    display: flex;
    padding-top: 0;
  }
`

const ListItemA = styled.li`
  color: #fff;
  font-size: 18px;
  font-family: 'BarlowSemiBold';
  list-style: none;
`

const ListItemB = styled.li`
  color: #fff;
  font-size: 16px;
  font-family: 'Barlow';
  list-style: none;

  &:first-child {
    font-family: 'BarlowSemiBold';
    font-size: 18px;
    padding-bottom: 18px;
  }

  @media ${device.tablet} {
    font-size: 15px;
    padding-right: 20px;

    &:first-child {
      font-size: 18px;
      padding-bottom: 0;
    }
  }

  @media ${device.laptopM} {
    padding-right: 11px;
  }
  @media ${device.laptopL} {
    padding-right: 18px;
  }
`

const ListItemC = styled.li`
  color: #4d4d4d!important;
  font-size: 22px;
  font-family: 'BarlowSemiBold';
  list-style: none;
`

const FooterLinkBlack = ({ children, to, href, ...props }) => (
  <ListItemA {...props}>
    <StyledLinkNormal
      href={href}
      style={{color: '#000'}}
    >
      {children}
    </StyledLinkNormal>
  </ListItemA>
)

const ItemA = ({ children, to, href, ...props }) => (
  <ListItemA {...props}>
    {href
      ? <StyledLinkNormal href={href}>{children}</StyledLinkNormal>
      : <StyledLink to={to}>{children}</StyledLink>
    }
  </ListItemA>
)

const ItemB = ({ children, to, ...props }) => (
  <ListItemB {...props}>
    {to.includes("noleggia")
      ? <StyledLink to={to}>{children}</StyledLink>
      : <StyledLinkNormal href={to}>{children}</StyledLinkNormal>
    }
  </ListItemB>
)

const ItemC = ({ children, to, href, ...props }) => (
  <ListItemC {...props} style={{
            fontWeight: 'bold',
            marginTop: 6,
    }}>
    {href
      ? <StyledLinkNormal href={href}
          style={{
            color: '#4d4d4d',
            fontWeight: 'bold',
          }}
        >{children}</StyledLinkNormal>
      : <StyledLink to={to}>{children}</StyledLink>
    }
  </ListItemC>
)

const FooterBottom = styled.div`
  border-top: 1px solid #4d4d4d;
  padding: 1.5rem 1.5rem 0 1.5rem;
  width: 100%;

  @media ${device.tablet} {
    display: flex;
    padding: 0;
  }
`

const FooterItem = styled.div`
  color: #4d4d4d;
  font-family: 'Barlow';
  font-size: 11px;

  @media ${device.tablet} {
    padding-left: 1em;
  }
`

const IconWrapper = styled.div`
  padding: 1.5em;

  @media ${device.tablet} {
    display: flex;
    align-items: flex-end;
    height: 100%;
  }
`

class Footer extends Component {
  componentDidMount () {
    const script = document.createElement('script')
    script.src = 'https://cdn.iubenda.com/iubenda.js'
    script.async = true
    document.body.appendChild(script)
  }

  render () {
    return (
      <Wrapper>
        <Section style={{ gridArea: 'logo' }}>
          <Logo white />
        </Section>
        <Section style={{ gridArea: 'contact' }}>
          <Title>
            <Link to='/contattaci'
              style={{
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              CONTATTI
            </Link>
          </Title>
          <List>
            {/* <ItemA href='tel:+39 02 54072548'>(+39) 02 54072548</ItemA> */}
            <ItemA href='mailto:info@noleggiocampi.it'>info@noleggiocampi.it</ItemA>
          </List>
        </Section>



        <Section style={{ gridArea: 'service' }}>
          <ItemC href='https://noleggiocampi.it'>HOME</ItemC>
          <ItemC href='https://noleggia.noleggiocampi.it/noleggia'>CONFIGURATORE</ItemC>
          <ItemC href='https://noleggiocampi.it/strutture'>VENDITA E NOLEGGIO</ItemC>
          <ItemC href='https://noleggiocampi.it/chi-siamo'>CHI SIAMO</ItemC>
          <ItemC href='https://noleggiocampi.it/contattaci'>CONTATTACI</ItemC>
        </Section>
        {/*   <Title>SERVIZIO CLIENTI</Title> */}
        {/*   <List> */}
        {/*     <ItemA href='https://noleggiocampi.it/faq'>FAQ</ItemA> */}
        {/*     <ItemA href='https://noleggiocampi.it/dove-noleggiamo'>Dove noleggiamo</ItemA> */}
        {/*   </List> */}
        {/* {menuItems.map((item, index) => { */}
        {/*   if (item.submenu) { */}
        {/*     return ( */}
        {/*       <React.Fragment key={index}> */}
        {/*         <HR /> */}
        {/*         <Section key={item.name} style={{ gridArea: item.name.toLowerCase() }}> */}
        {/*           <StyledLink to={item.url}><Title>{item.name}</Title></StyledLink> */}
        {/*           {item.submenu.headers.map((header, index) => ( */}
        {/*             <MenuList key={header.name}> */}
        {/*               <ItemB to={header.url}>{header.name}</ItemB> */}
        {/*               {item.submenu.lists[index].map(listItem => ( */}
        {/*                 <ItemB key={listItem.name} to={listItem.url}>{listItem.name}</ItemB> */}
        {/*               ))} */}
        {/*             </MenuList> */}
        {/*           ))} */}
        {/*         </Section> */}
        {/*       </React.Fragment> */}
        {/*     ) */}
        {/*   } */}
        {/* })} */}



        <IconWrapper style={{ gridArea: 'social' }}>
          <IconNav />
        </IconWrapper>
        <FooterBottom style={{ gridArea: 'footer' }}>
          <FooterItem>&copy; NOLEGGIOCAMPI.IT È UN MARCHIO DI AD4 SRLS</FooterItem>
          <FooterItem>P.IVA 09076750968</FooterItem>
          <FooterItem>
            <FooterLinkA href='https://www.iubenda.com/privacy-policy/21238999' className='iubenda-nostyle no-brand iubenda-embed' title='Privacy Policy'>PRIVACY</FooterLinkA> -
            <FooterLinkA href='https://www.iubenda.com/privacy-policy/21238999/cookie-policy' className='iubenda-nostyle no-brand iubenda-embed ' title='Cookie Policy'> COOKIES</FooterLinkA> -
            <FooterLinkA href='https://noleggiocampi.it/condizioni'> CONDIZIONI</FooterLinkA>
          </FooterItem>
        </FooterBottom>
      </Wrapper>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/UI/Footer/index.js